import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";
import {BemSubtipo} from "./bem-subtipo.model";

@Injectable()
export class BemSubtipoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: BemSubtipo, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: BemSubtipo, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"subTipo"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":"tipoBem"};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetByTipo(tipoId: number, done: any) {
    var filter: any = {"where":{"tipoBemId":tipoId},"order":"subTipo"};
    this._restService.onGetPost(apiName, filter, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/shared/bem-subtipo-api.service.ts
 **/